import(/* webpackMode: "eager", webpackExports: ["CarouselItem"] */ "/vercel/path0/app/components/molecules/Carousel/carousel-item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CarouselNavigation"] */ "/vercel/path0/app/components/molecules/Carousel/carousel-navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/molecules/DarkMode/dark-mode.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/molecules/EmailSubsriptionForm/email-subscription-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/molecules/LanguageSwitcher/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConditionalTrendingBadge"] */ "/vercel/path0/app/components/molecules/TrendingBadge/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/navigation/header-nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CarouselContent"] */ "/vercel/path0/app/components/organisms/Carousel/carousel-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Carousel"] */ "/vercel/path0/app/components/organisms/Carousel/carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/organisms/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/organisms/Header/SessionWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/organisms/Hero/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Modals"] */ "/vercel/path0/app/components/organisms/Modal/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/templates/Banner/banner.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/public/images/ads.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/public/images/feature-product-image.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/public/images/subscription.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/public/svg/logo_vectorized.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/public/svg/logo.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
